<div *ngIf="isLoading">
    <po-loading-overlay [p-text]="text" [p-size]="size">
    </po-loading-overlay>
</div>
<app-toaster></app-toaster>

<div class="po-wrapper">
    <po-page-default>
        <div class="row po-font-text-small po-mb-3">
            <app-step-breadcrumb [breadcrumbs]="breadcrumbs" [activeIndex]="inventoryStep"
                (breadcrumbClick)="navigateBreadcrumb($event)"></app-step-breadcrumb>
        </div>
        <div *ngIf="inventoryStep == InventoryCountStepEnum.InventoryHeader">
            <app-inventory-header (isLoading)="onLoadingChange($event)"
                (onOpenInventoryCount)="onInventoryHeaderSelected($event)"></app-inventory-header>
        </div>
        <div *ngIf="inventoryStep == InventoryCountStepEnum.InventoryCount">
            <app-inventory-count (isLoading)="onLoadingChange($event)" [inventoryHeader]="inventoryModel"
                (inventoryCountSelected)="onInventoryCountSelected($event)"></app-inventory-count>
        </div>
        <div *ngIf="inventoryStep == InventoryCountStepEnum.InventoryCountDetail">
            <app-inventory-count-detail (isLoading)="onLoadingChange($event)" [InventoryModel]="inventoryModel"
                [inventoryCountModel]="inventoryCountModel"
                (onCountFinished)="onInventoryCountFinished()"></app-inventory-count-detail>
        </div>
    </po-page-default>
</div>